import { create } from 'zustand';
import { getOrgQualifications, saveOrgQualifications } from '@libs/api/settings';
import { QualificationSettings } from '@libs/models/settings';

type InitialState = {
  loading: boolean;
  initiated: boolean;
  editDirectQualDrawerOpen: boolean;
  editOtherQualDrawerOpen: boolean;
  orgQualifications?: QualificationSettings;
  save: (settings: QualificationSettings) => Promise<void>;
  load: () => void;
  setDirectDrawerOpen: (isOpen: boolean) => void;
  setOtherDrawerOpen: (isOpen: boolean) => void;
};

export const useOrgQualificationsStore = create<InitialState>()((set, get) => ({
  loading: false,
  initiated: false,
  editDirectQualDrawerOpen: false,
  editOtherQualDrawerOpen: false,
  save: async (settings) => {
    if (!settings) return;
    await saveOrgQualifications(settings);
    set({ orgQualifications: settings });
  },
  load: async (force = false) => {
    const { orgQualifications, loading } = get();
    if (loading && orgQualifications && !force) {
      return;
    }
    set({ loading: true });
    try {
      // TODO: use real ID
      const setting = await getOrgQualifications();
      set({ loading: false, orgQualifications: setting, initiated: true });
    } finally {
      set({ loading: false });
    }
  },
  setDirectDrawerOpen: (isOpen) => {
    set({ editOtherQualDrawerOpen: false });
    set({ editDirectQualDrawerOpen: !!isOpen });
  },
  setOtherDrawerOpen: (isOpen) => {
    set({ editDirectQualDrawerOpen: false });
    set({ editOtherQualDrawerOpen: !!isOpen });
  },
}));
